import LocalizedStrings from "react-localization";
import { isValidPhoneNumber } from "react-phone-number-input";

const validateConditions = (condition, value) => {
  if (condition === "isRequired")
    return (!value || value?.length <= 0) && strings.validations.isRequired;
  if (condition === "isEmail" && value) {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return !regex.test(value) && strings.validations.isEmail;
  }
  if (condition === "isNumber" && value) {
    const regex = /^[0-9]+$/;
    return !regex.test(value) && strings.validations.isNumber;
  }
  if (condition === "isPhone" && value)
    return !isValidPhoneNumber(value) && strings.validations.isPhone;
  return null;
};

const useErrors = (validations = {}) => {
  const validateErrors = (name, value) => {
    const validationValue = validations[name];
    let errorMessage = "";
    if (!validationValue) return;
    if (Array.isArray(validationValue))
      validationValue.forEach((itemValidationValue) => {
        if (!errorMessage)
          errorMessage = validateConditions(itemValidationValue, value);
      });
    else {
      errorMessage = validateConditions(validationValue, value);
    }
    return errorMessage;
  };

  return validateErrors;
};

const strings = new LocalizedStrings({
  es: {
    validations: {
      isRequired: "El campo es requerido",
      isEmail: "El campo debe ser un correo electrónico válido",
      isNumber: "El campo debe contener únicamente números",
      isPhone: "El campo debe ser un teléfono válido",
    },
  },
});

export default useErrors;
